export interface KnowledgeArticle {
  id: string;
  article_code: string;
  category: string;
  subCategory: string;
  tags: string[];
  title: string;
  description: string;
  suggestedReply: string;
  sop: string[];
  departments: string[];
  relatedIds: string[];
}

export interface KnowledgeCategory {
  id: string;
  label: string;
  count: number;
  subCategories: string[];
}

export interface DbKnowledgeArticle {
  id: string;
  article_code: string;
  category: string;
  sub_category: string;
  tags: string[];
  title: string;
  description: string;
  suggested_reply: string;
  sop: string[];
  departments: string[];
  related_ids: string[];
  created_at: string;
  updated_at: string;
}

export function convertFromDb(row: DbKnowledgeArticle): KnowledgeArticle {
  return {
    id: row.id,
    article_code: row.article_code,
    category: row.category,
    subCategory: row.sub_category,
    tags: row.tags || [],
    title: row.title,
    description: row.description,
    suggestedReply: row.suggested_reply,
    sop: row.sop || [],
    departments: row.departments || [],
    relatedIds: row.related_ids || [],
  };
}

export const knowledgeCategories: KnowledgeCategory[] = [
  {
    id: "all",
    label: "全部",
    count: 0,
    subCategories: [],
  },
  {
    id: "product",
    label: "商品 / 訂單",
    count: 0,
    subCategories: [
      "退貨退款",
      "規格",
      "年齡建議",
      "傳送",
      "保修",
      "退換貨",
      "商品推薦",
      "退款原因",
      "訂單處理",
      "物流退貨",
    ],
  },
  {
    id: "logistics",
    label: "貨運 / 物流",
    count: 0,
    subCategories: [
      "物流進度",
      "異常處理",
      "配送問題",
      "指定司機",
      "運費",
      "系統問題",
      "Bug",
      "功能諮詢",
    ],
  },
  {
    id: "employee",
    label: "員工 / 人事",
    count: 0,
    subCategories: [
      "入職須知",
      "考勤制度",
      "薪資福利",
      "行為規範",
    ],
  },
  {
    id: "wine",
    label: "酒類知識",
    count: 0,
    subCategories: [
      "保存儲藏",
      "品酒技巧",
      "年份解析",
      "產區風土",
      "葡萄品種",
      "選購指南",
      "釀造工藝",
      "餐酒搭配",
    ],
  },
];